import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'
import classNames from 'classnames'

import type { ReactElement } from 'react'

import UserCard from '~/components/UserCard'
import { useUserDetailsQuery } from '~/queries/users'
import { convertToMilliseconds } from '~/utils/date'
import { capitalize } from '~/utils/string'

import './styles.scss'

interface Props {
  background?: 'black' | 'colored' | 'default'
  className?: string
  label?: string
  labelClassName?: string
  labelPosition?: 'top' | 'left'
  size?: Exclude<SIZES, 'large'>
  updatedBy: {
    date: number
    name: string
    picture?: string
    userId?: string
  }
}

const LastUpdatedByCard = ({
  background,
  className,
  label = 'Last update by',
  labelClassName,
  labelPosition = 'left',
  size = 'medium',
  updatedBy,
}: Props): ReactElement => {
  const componentClasses = classNames('last-updated-card-component', className)

  const user = useUserDetailsQuery(updatedBy.userId)

  const name = user.data?.name || updatedBy.name

  const picture = user.data?.picture || updatedBy.picture

  return (
    <div className={componentClasses}>
      <UserCard
        backgroundColor={background}
        label={label}
        labelClassName={labelClassName}
        labelPosition={labelPosition}
        name={capitalize(name)}
        picture={picture}
        size={size}
        subInfo={formatDate(convertToMilliseconds(updatedBy.date), DATE_FORMATS.DEFAULT_WITH_HOURS)}
      />
    </div>
  )
}

export default LastUpdatedByCard
